"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVENESS_DOSSIER_DECISION = exports.DOCUMENT_VALIDATION_CODES = void 0;
exports.getDocumentValidationOutcome = getDocumentValidationOutcome;
exports.getFaceValidationOutcome = getFaceValidationOutcome;
exports.getLatestFaceAttempt = getLatestFaceAttempt;
exports.getLivenessDossierDecision = getLivenessDossierDecision;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var DOCUMENT_VALIDATION_CODES = exports.DOCUMENT_VALIDATION_CODES = Object.freeze({
  approved: Object.freeze(['0', '14', '16']),
  attention: Object.freeze(['5', '7', '8', '10', '11', '12', '99']),
  rejected: Object.freeze(['1', '2', '3', '15'])
});
var LIVENESS_DOSSIER_DECISION = exports.LIVENESS_DOSSIER_DECISION = Object.freeze({
  canceled: Object.freeze({
    key: 'canceled',
    label: 'Processo Cancelado'
  }),
  rejected: Object.freeze({
    key: 'rejected',
    label: 'Reprovado Automaticamente'
  }),
  approved: Object.freeze({
    key: 'approved',
    label: 'Aprovado Automaticamente'
  }),
  pending: Object.freeze({
    key: 'pending',
    label: 'Em Análise'
  })
});
var COMPLETED_STATUSES = ['completed', 'concluido', 'concluído'];
var FAILED_STATUSES = ['canceled', 'cancelled', 'cancelado', 'error', 'erro', 'failed', 'falha', 'expired', 'expirado'];
function normalizeStatus(value) {
  return String(value || '').trim().toLowerCase();
}
function isCompletedStatus(value) {
  return COMPLETED_STATUSES.includes(normalizeStatus(value));
}
function isFailedStatus(value) {
  return FAILED_STATUSES.includes(normalizeStatus(value));
}
function getDocumentValidationOutcome(documentoscopia) {
  if (documentoscopia === null || documentoscopia === undefined || documentoscopia === '') {
    return null;
  }
  var code = String(documentoscopia);
  return Object.keys(DOCUMENT_VALIDATION_CODES).find(function (outcome) {
    return DOCUMENT_VALIDATION_CODES[outcome].includes(code);
  }) || null;
}
function getLatestFaceAttempt() {
  var validation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attempts = Array.isArray(validation === null || validation === void 0 ? void 0 : validation.faceHistory) ? validation.faceHistory.filter(function (attempt) {
    return attempt && _typeof(attempt) === 'object';
  }) : [];
  return attempts.reduce(function (latest, attempt) {
    if (!latest) return attempt;
    var latestTimestamp = new Date((latest === null || latest === void 0 ? void 0 : latest.createdAt) || 0).getTime();
    var attemptTimestamp = new Date((attempt === null || attempt === void 0 ? void 0 : attempt.createdAt) || 0).getTime();
    return attemptTimestamp >= latestTimestamp ? attempt : latest;
  }, null);
}
function getFaceValidationOutcome() {
  var validation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attempt = getLatestFaceAttempt(validation);
  if (!attempt) {
    return null;
  }
  var liveness = (attempt === null || attempt === void 0 ? void 0 : attempt.liveness) || {};
  var rawScore = attempt === null || attempt === void 0 ? void 0 : attempt.facematch;
  var score = Number(rawScore);
  var hasScore = rawScore !== null && rawScore !== undefined && rawScore !== '' && !Number.isNaN(score);
  var criticalChecks = [liveness === null || liveness === void 0 ? void 0 : liveness.success, liveness === null || liveness === void 0 ? void 0 : liveness.wasProcessed, liveness === null || liveness === void 0 ? void 0 : liveness.auditTrailVerificationSucceeded, liveness === null || liveness === void 0 ? void 0 : liveness.faceScanSucceeded, liveness === null || liveness === void 0 ? void 0 : liveness.replayCheckSucceeded, liveness === null || liveness === void 0 ? void 0 : liveness.sessionTokenCheckSucceeded].filter(function (value) {
    return typeof value === 'boolean';
  });
  var hasFailure = (attempt === null || attempt === void 0 ? void 0 : attempt.spoof) === true || isFailedStatus(attempt === null || attempt === void 0 ? void 0 : attempt.status) || isFailedStatus(liveness === null || liveness === void 0 ? void 0 : liveness.status) || criticalChecks.some(function (value) {
    return value === false;
  }) || hasScore && score < 0;
  if (hasFailure) {
    return 'rejected';
  }
  var isCompleted = isCompletedStatus(attempt === null || attempt === void 0 ? void 0 : attempt.status) || isCompletedStatus(liveness === null || liveness === void 0 ? void 0 : liveness.status);
  var hasApprovedSignal = criticalChecks.some(function (value) {
    return value === true;
  }) || hasScore && score >= 0;
  return isCompleted && hasApprovedSignal ? 'approved' : null;
}
function getLivenessDossierDecision() {
  var validation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var processStatusKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (processStatusKey === 'canceled') {
    return LIVENESS_DOSSIER_DECISION.canceled;
  }
  var flow = Array.isArray(validation === null || validation === void 0 ? void 0 : validation.flow) ? validation.flow : [];
  var faceAttempt = getLatestFaceAttempt(validation);
  var documents = validation === null || validation === void 0 ? void 0 : validation.documents;
  var requiresFace = flow.some(function (step) {
    return ['selfie', 'selfieFace'].includes(step);
  }) || Boolean(faceAttempt);
  var requiresDocuments = flow.includes('documents') || Boolean(documents);
  var outcomes = [];
  if (requiresFace) {
    outcomes.push(getFaceValidationOutcome(validation));
  }
  if (requiresDocuments) {
    var documentOutcome = getDocumentValidationOutcome(documents === null || documents === void 0 ? void 0 : documents.documentoscopia);
    if (isFailedStatus(documents === null || documents === void 0 ? void 0 : documents.status)) {
      outcomes.push('rejected');
    } else if (!isCompletedStatus(documents === null || documents === void 0 ? void 0 : documents.status) || !documentOutcome) {
      outcomes.push(null);
    } else {
      outcomes.push(documentOutcome === 'approved' ? 'approved' : 'rejected');
    }
  }
  if (outcomes.some(function (outcome) {
    return outcome === 'rejected';
  })) {
    return LIVENESS_DOSSIER_DECISION.rejected;
  }
  if (outcomes.length && outcomes.every(function (outcome) {
    return outcome === 'approved';
  })) {
    return LIVENESS_DOSSIER_DECISION.approved;
  }
  return LIVENESS_DOSSIER_DECISION.pending;
}